import { ReactNode } from "react";

import { Content } from "./components";
import { AccountCreationContextProvider } from "./hooks";

export const AccountCreation = ({
    continueUrl,
    identityCobranding,
    templateId,
    ...props
}: {
    continueUrl?: string;
    identityCobranding?: string;
    templateId?: string;
    Error?: ReactNode;
    Input?: ReactNode;
    Login?: ReactNode;
    Separator?: ReactNode;
    Social?: ReactNode;
    Submit?: ReactNode;
}) => (
    <AccountCreationContextProvider
        continueUrl={continueUrl}
        identityCobranding={identityCobranding}
        templateId={templateId}
    >
        <Content {...props} />
    </AccountCreationContextProvider>
);
